import { PersonalRealEstateLoansSummarySumTable } from '../../../TtDetails';
import { useTotalTermElementDetailViewSummaryPage } from './hooks';
import { TotalTermElementDetailViewPersonalRealEstateLoansPageProps } from './types';
import { SummaryPageContainer } from './components';

export function TotalTermElementDetailViewPersonalRealEstateLoansPage({
  householdID,
  onClickItem,
}: TotalTermElementDetailViewPersonalRealEstateLoansPageProps) {
  const { tPages } = useTotalTermElementDetailViewSummaryPage();

  return (
    <SummaryPageContainer
      heading={tPages('total-term-element-detail-view-personal-real-estate-loans-summary-page-heading')}
      emptyDescription={tPages(
        'total-term-element-detail-view-personal-real-estate-loans-summary-page-empty-description'
      )}
    >
      <PersonalRealEstateLoansSummarySumTable
        hideOnEmpty
        className="mt-10"
        householdID={householdID}
        onClickItem={onClickItem}
      />
    </SummaryPageContainer>
  );
}
